import _ from "lodash";
import { absolutePath } from "./absolutePath";

export interface ProrationParams {
  new_plan_id: string | number;
  plan_coupon_id?: string | number;
}

export interface FetchPlanParams {
  tier?: string;
  id?: string;
  billing_currency?: string | null;
  locale?: string | null;
  plan_type?: string;
  isPriceTestingEnabled?: boolean;
}

export interface FetchPlansParams {
  billing_cycle?: string | null;
  billing_currency?: string | null;
  locale?: string | null;
  isPriceTestingEnabled?: boolean;
}

export interface FetchEmailHubPlanParams {
  billing_currency?: string | null;
  locale?: string | null;
}

const cleanParams = (params: Record<string, unknown>) =>
  _.omitBy(params, value => _.isNil(value) || value === "");

const experimentedPlanPath = (
  isPriceTestingEnabled: boolean,
  basePath: string,
) =>
  isPriceTestingEnabled ? `communities/experimentation/${basePath}` : basePath;

export const plans = {
  proration: ({ new_plan_id, plan_coupon_id = "" }: ProrationParams) =>
    absolutePath(
      "plans/prorations",
      cleanParams({ new_plan_id, plan_coupon_id }),
    ),

  fetch: ({
    tier,
    id,
    billing_currency,
    locale,
    plan_type,
    isPriceTestingEnabled = false,
  }: FetchPlanParams) => {
    const base = tier ? { tier } : id ? { id } : {};
    const params = cleanParams({
      ...base,
      billing_currency,
      locale,
      plan_type,
    });
    const path = experimentedPlanPath(isPriceTestingEnabled, "plan");

    return absolutePath(path, params);
  },

  fetchPlans: ({
    billing_cycle,
    billing_currency,
    locale,
    isPriceTestingEnabled = false,
  }: FetchPlansParams = {}) => {
    const params = cleanParams({ billing_cycle, billing_currency, locale });
    const path = experimentedPlanPath(isPriceTestingEnabled, "plans");

    return absolutePath(path, params);
  },

  fetchEmailHubPlan: ({
    billing_currency,
    locale,
  }: FetchEmailHubPlanParams) => {
    const params = cleanParams({ billing_currency, locale });

    return absolutePath("email_hub/plans", params);
  },
};
